"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _AvatarImage = _interopRequireDefault(require("../avatar/AvatarImage"));

var _avatarConstants = require("../avatar/avatarConstants");

var _getUniqueId = require("../utils/getUniqueId");

var _context = require("../context");

var _layout = require("../layout");

var _text = require("../text");

var _utils = require("../utils");

var _TagDismissButton = require("./TagDismissButton");

var _constants = require("./constants");

var _getPadding = require("./getPadding");

var _propTypes = _interopRequireDefault(require("./propTypes"));

var _core = require("@emotion/core");

var _excluded = ["children", "onDismiss", "tagDeleteButtonRef", "dismissButtonAltText", "avatarUsername", "avatarEmployeeId", "backgroundColor"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var TagWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      onDismiss = _ref.onDismiss,
      tagDeleteButtonRef = _ref.tagDeleteButtonRef,
      _ref$dismissButtonAlt = _ref.dismissButtonAltText,
      dismissButtonAltText = _ref$dismissButtonAlt === void 0 ? _constants.defaultProps.dismissButtonAltText : _ref$dismissButtonAlt,
      avatarUsername = _ref.avatarUsername,
      avatarEmployeeId = _ref.avatarEmployeeId,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? _constants.defaultProps.backgroundColor : _ref$backgroundColor,
      htmlProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      theme = _useContext.theme,
      selectors = _useContext.selectors;

  var uniqueId = (0, _react.useMemo)(function () {
    return "tag-".concat((0, _getUniqueId.getUniqueId)(), "-id");
  }, []);
  var tagId = !!onDismiss ? uniqueId : undefined;
  var imageSource = avatarEmployeeId ? "".concat(_avatarConstants.BADGE_PHOTO_URL, "?employeeId=").concat(avatarEmployeeId) : "".concat(_avatarConstants.BADGE_PHOTO_URL, "?uid=").concat(avatarUsername);
  var padding = (0, _getPadding.getPadding)(theme, !!onDismiss);
  return (0, _core.jsx)("div", (0, _extends2.default)({
    ref: ref
  }, htmlProps), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    backgroundColor: backgroundColor,
    width: "max-content",
    maxWidth: "100%"
  }, !!avatarUsername && (0, _core.jsx)(_AvatarImage.default, {
    selectors: selectors,
    source: imageSource,
    shouldAnnounceImageAltText: false,
    marginRight: 0,
    size: _constants.DEFAULT_HEIGHT
  }), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: _constants.DISMISS_BUTTON_GAP,
    padding: padding
  }, (0, _core.jsx)(_text.Text, {
    fontSize: _constants.FONT_SIZE,
    color: _constants.FOREGROUND_COLOR,
    id: tagId
  }, children), !!onDismiss && (0, _core.jsx)(_TagDismissButton.TagDismissButton, {
    tagId: tagId,
    onDismiss: onDismiss,
    dismissButtonAltText: dismissButtonAltText,
    ref: tagDeleteButtonRef
  }))));
});
var TagWithDocs = (0, _stencilReactDesc.describe)(TagWithoutDocs).description('Element providing a small amount of information.');
TagWithDocs.propTypes = _propTypes.default;
TagWithDocs.defaultProps = _objectSpread({}, _constants.defaultProps);
var Tag = (0, _utils.withTestAttributes)({
  component: 'StencilTag'
})(TagWithDocs);
Tag.displayName = 'Tag';
var _default = Tag;
exports.default = _default;